/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useState,
  useEffect,
  useRef
} from 'react'

import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'
import Lottie from "lottie-react";

import LoadingContent from '../../modules/loading/LoadingContent'
import LoadingBranch from '../../modules/loading/LoadingBranch'
import paymentAnimation  from '../../../_metronic/assets/animations/payment.json';
import paymentRejectedAnimation  from '../../../_metronic/assets/animations/paymentRejected.json';

import SupportOption from 'app/pages/HelpCenter/SupportOption';

import {
  fetchCredit,
} from 'app/services/credits'

import {
  formatLongDateToDate,
  parseWeekDays,
} from 'app/services/dates'

const Credit = () => {
  const { auth, credits } = useSelector((state : any) => ({
    auth: state.auth,
    credits: state.credits,
  }), shallowEqual);

  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [credit, setCredit] = useState<any>({});

  const [openDeleteSchedule, setOpenDeleteSchedule] = useState<any>(false);

  const lottieRef = useRef<any>();

  useEffect(() => {
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: 'app-modal-open' }))
    }
    return () => {
      if ((window as any).ReactNativeWebView) {
        (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: 'app-modal-close' }))
      }
    }
  }, []);

  useEffect(() => {
    setCredit({});

    getCreditPurchase();
  }, []);

  useEffect(() => {
    if(!auth.user) {
      navigate('/')
    }
  }, [auth]);

  const getCreditPurchase = () => {
    dispatch<any>(fetchCredit(id)).then(response => {
      setCredit(response);
    }).catch((error) => {
      navigate('/compras/creditos');
    });
  }

  const getBranch = (value) => {
    if (value.relationships.origin.type == 'service') {
      return value.relationships.origin.relationships.fields[0].relationships.branch

    }

    if (value.relationships.origin.type == 'plan') {
      return value.relationships.origin.relationships.branches[0]
    }
  }

  const getTypeLabel = (value: any) => {
    if (value.relationships.origin.type === 'plan') {
      if (value.relationships.origin.attributes.type === 'day_use') {
        return 'Day use';
      }
    }

    if (value.relationships.origin.type === 'service') {
      if (value.relationships.origin.attributes.modality === 'reservation') {
        return 'Locação';
      }
      if (value.relationships.origin.attributes.modality === 'class') {
        return 'Aula';
      }
    }

    return value.relationships.origin.attributes.type;
  }

  const getOriginLabel = (value: any) => {
    if (value.attributes.type === 'branch') {
      return 'Concedido pela unidade';
    }
    if (value.attributes.type === 'purchase') {
      return 'Compra de pacote';
    }
    if (value.attributes.type === 'refund') {
      return 'Reposição';
    }

    return value.attributes.type;
  }

  return (
    <>
    <div id="kt_app_content" className="flex-column-fluid">
      <span className="btn btn-md btn-icon btn-bg-light btn-active-color-primary w-100px h-40px cursor-pointer mb-5" onClick={() => navigate('/compras/creditos')}>
        <i className="las la-arrow-left fw-bold fs-2 text-primary me-3" />
        Voltar
      </span>
      <div className="d-flex flex-column flex-lg-row">
        <div className="flex-lg-row-fluid mb-5 mb-lg-0">
          <div className='card mb-5 mb-sm-0'>
            <div className='card-body pt-5'>
              <div className="justify-content-space-between d-flex mb-5">
                <span className="flex-root text-center fs-2 fw-bold">
                  Detalhes do crédito
                </span>
              </div>
              <div className="row mt-10">

                {(credit?.relationships?.status?.attributes?.name === 'active' && credit?.attributes?.is_active) && <div className="col-md-8 col-lg-6 mb-5 mb-md-0 offset-lg-3 offset-md-2">
                  <div className="flex-root justify-content-center text-center">
                    <div className="card border border-1 border-gray-200 bg-gray-300 w-100">
                      <div className="d-flex flex-stack justify-content-center text-center me-2">
                        <Lottie
                          style={{
                            width: 50,
                            height: 50,
                          }}
                          animationData={paymentAnimation}
                          loop={false}
                          autoplay
                          rendererSettings={{
                            preserveAspectRatio: 'xMidYMid slice',
                          }}
                          initialSegment={[0,22]}
                        />
                        <div className="fs-5 opacity-75 fw-bold px-3">
                          Disponível para uso
                        </div>
                      </div>
                    </div>
                    <div className="fs-6 opacity-50 mt-5">
                      Seu crédito está disponível para uso, agora é só chamar os amigos e jogar!
                    </div>
                  </div>
                </div>}

                {credit?.relationships?.status?.attributes?.name === 'paid' && <div className="col-md-8 col-lg-6 mb-5 mb-md-0 offset-lg-3 offset-md-2">
                  <div className="flex-root justify-content-center text-center">
                    <div className="card border border-1 border-gray-200 bg-gray-300 w-100">
                      <div className="d-flex flex-stack justify-content-center text-center me-2">
                        <div className="fs-5 opacity-75 fw-bold px-3 py-3">
                          Crédito utilizado
                        </div>
                      </div>
                    </div>
                    <div className="fs-6 opacity-50 mt-5">
                      Seu crédito já foi utilizado.
                    </div>
                    <div className="fs-6 opacity-50 mt-5">
                      Adquira agora novos créditos e continue jogando!
                    </div>
                  </div>
                </div>}

                {(
                  credit?.relationships?.status?.attributes?.name === 'expired' ||
                  (credit?.relationships?.status?.attributes?.name !== 'paid' && credit?.attributes?.is_expired)
                ) && <div className="col-md-8 col-lg-6 mb-5 mb-md-0 offset-lg-3 offset-md-2">
                  <div className="flex-root justify-content-center text-center">
                    <div className="card border border-1 border-gray-200 bg-gray-300 p-3 w-100">
                      <div className="d-flex flex-stack justify-content-center text-center me-2">
                        <Lottie
                          style={{
                            width: 30,
                            height: 30,
                          }}
                          lottieRef={lottieRef}
                          animationData={paymentRejectedAnimation}
                          loop={false}
                          onDOMLoaded={() => lottieRef.current?.setSpeed(1.4)}
                          autoplay
                        />

                        <div className="fs-5 opacity-75 fw-bold px-3">Crédito expirado</div>
                      </div>
                    </div>
                    <div className="fs-6 opacity-50 mt-5">
                      Seu crédito está expirado.
                    </div>
                    <div className="fs-6 opacity-50 mt-5">
                    Adquira agora novos créditos e continue jogando!
                    </div>
                  </div>
                </div>}
              </div>

              {credit?.id && <div className="row mt-5">
                <div className="col-lg-12">
                  <div className="justify-content-space-between d-flex mb-2">
                    <span className="flex-root fs-3 fw-bold text-primary">
                      Informações
                    </span>
                  </div>
                  <div className='table-responsive'>
                    <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='border-0'>
                          <th className='p-0 w-140px'></th>
                          <th className='p-0 min-w-140px'></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              Unidade
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>{getBranch(credit).attributes?.name}</td>
                        </tr>
                        <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              Serviço
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>{credit.relationships.origin.attributes.name}</td>
                        </tr>
                        <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              Tipo
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>{getTypeLabel(credit)}</td>
                        </tr>
                        <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              Aquisição
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>
                            {getOriginLabel(credit)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>}

              {credits.listLoading === false && !credit?.id && <div className="mb-13 text-center">
                <h2 className="mb-3">
                  Ops, compra não encontrada!
                </h2>
                <div className="text-muted fw-semibold fs-5">
                  Não encontramos a página que você procura!
                </div>
                <div className="text-muted fw-semibold fs-5">
                  Verifique a url ou tente novamente.
                </div>
              </div>}

              {(credits.listLoading === true) && !credit?.id && <LoadingContent />}
            </div>
          </div>
        </div>

        <div className="flex-lg-auto min-w-lg-400px ms-lg-10">
          <div className='card mb-5'>
            <div className='card-body pt-5 pb-0 mb-5'>
              <div className="mb-5 text-center">
                <span className="flex-root text-center fs-2 fw-bold mb-3">
                  Pagamento
                </span>
              </div>
              {credit?.id && <>
                <div className="row mt-5">
                  <div className="col-lg-12">
                    <div className="justify-content-space-between d-flex mb-2">
                      <span className="flex-root fs-3 fw-bold text-primary">
                        Regras de utilização
                      </span>
                    </div>
                    <div className='table-responsive'>
                      <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                        <thead>
                          <tr className='border-0'>
                            <th className='p-0 w-140px'></th>
                            <th className='p-0 min-w-140px'></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <span className='text-muted fw-bold mb-1 fs-6'>
                                Dias da semana
                              </span>
                            </td>
                            <td className='text-end text-dark fw-semibold'>
                              {parseWeekDays(credit.attributes.weekdays, true)}
                            </td>
                          </tr>
                          {credit?.attributes?.start_at && credit?.attributes?.end_at && <tr>
                            <td>
                              <span className='text-muted fw-bold mb-1 fs-6'>
                                Limite de horário
                              </span>
                            </td>
                            <td className='text-end text-dark fw-semibold'>
                              Das {credit.attributes.start_at} até {credit.attributes.end_at}
                            </td>
                          </tr>}
                          <tr>
                            <td>
                              <span className='text-muted fw-bold mb-1 fs-6'>
                                {!credit.attributes.paid_at ? 'Válidade' : 'Data da utilização'}
                              </span>
                            </td>
                            <td className='text-end text-dark fw-semibold'>
                              {credit.attributes.paid_at && formatLongDateToDate(credit.attributes.paid_at, true)}
                              {!credit.attributes.paid_at && credit.attributes.expired_at && formatLongDateToDate(credit.attributes.expired_at, true)}
                              {!credit.attributes.paid_at && !credit.attributes.expired_at && `Não expira`}
                            </td>
                          </tr>
                          {/* <tr>
                            <td>
                              <span className='fs-3 text-white fw-bold mb-1 fs-6'>
                                Total
                              </span>
                            </td>
                            <td className='fs-3 text-end text-primary fw-bold'>
                              {invoice?.attributes?.payment_type === 'online' && invoice?.attributes?.payment_method === 'credit' && <span>
                                1 Crédito
                              </span>}

                              {!(invoice?.attributes?.payment_type === 'online' && invoice?.attributes?.payment_method === 'credit') && <>
                                {invoice?.attributes?.price && invoice?.attributes?.price !== invoice?.attributes?.full_price && <span className="fs-7 text-gray-700 lineThrough me-2">
                                  {formatMoney(invoice?.attributes?.price)}
                                </span>}

                                <span>
                                  {formatMoney(invoice?.attributes?.full_price)}
                                </span>
                              </>}
                            </td>
                          </tr> */}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col-lg-12">
                    <div className="justify-content-space-between d-flex mb-2">
                      <span className="flex-root fs-3 fw-bold text-primary">
                        Precisa de ajuda?
                      </span>
                    </div>
                    <div className='table-responsive'>
                      <SupportOption
                        originType={'credit'}
                        originId={credit && credit.id}
                        canCancel={false}
                        phone={credit?.id && getBranch(credit).attributes?.phone}
                        cancel={() => setOpenDeleteSchedule(true)}
                      />
                    </div>
                  </div>
                </div>
              </>}

              {(credits.listLoading === true) && !credit?.id && <LoadingBranch />}
            </div>
          </div>
        </div>
      </div>
    </div>
  </>)
}

export {
  Credit
}
